module.exports = "<p>\nImport Branding Dialog Component\n</p>\n"